module.exports = __webpack_public_path__ + "img/error-status-icon.e4873616.svg";